/**
 * Created by xiaoxudoo on 17/1/18.
 */
var isPro = !__DEV__
var proConf  = {
    
};
var devConf = {
    
};

var Rxports = {
    
}

module.exports = Rxports


// WEBPACK FOOTER //
// ./src/config.js